export const ProductGridSkeleton: React.FC = () => (
    <div className="container mx-auto px-4 sm:px-6">
        <div className="h-6 w-1/3 rounded animate-pulse mb-10" style={{ backgroundColor: `rgba(245, 236, 213, 0.1)` }} />
        <div className="h-12 w-3/5 rounded animate-pulse mb-6" style={{ backgroundColor: `rgba(245, 236, 213, 0.1)` }} />
        <div className="h-1 w-24 mb-12 rounded-full animate-pulse" style={{ backgroundColor: `rgba(240, 187, 120, 0.5)` }}/>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8">
            {[...Array(8)].map((_, j) => (
                <div key={j} className="animate-pulse">
                    <div className="w-full aspect-[4/3] rounded-t-2xl" style={{ backgroundColor: `rgba(245, 236, 213, 0.1)` }}/>
                    <div className="p-5 rounded-b-2xl" style={{ backgroundColor: `rgba(245, 236, 213, 0.05)` }}>
                        <div className="h-6 w-3/4 rounded mb-2" style={{ backgroundColor: `rgba(245, 236, 213, 0.1)` }}/>
                        <div className="h-4 w-1/2 rounded" style={{ backgroundColor: `rgba(245, 236, 213, 0.1)` }}/>
                    </div>
                </div>
            ))}
        </div>
    </div>
);